jQuery(document).ready(function($){

    // show appointment modal when present
    if ( $('#modalOnlineMembershipAppointment').length )
    {
        $('#modalOnlineMembershipAppointment').modal('show');
    }

    // highlight column on membership detail modal open
    $('[data-target="#modalMembershipDetail"][data-highlight]').on('click', function(){
        const highlight = $(this).data('highlight');
        $('.MembershipPrice').attr('data-highlight', highlight);
    });

    // remove highlight when modal closed
    $('#modalMembershipDetail').on('hidden.bs.modal', function(){
        $('.MembershipPrice').removeAttr('data-highlight');
    });

    // switch close icon for 'back to results' text, when opened via #modalOnlineMembershipAppointment modal
    $('#modalMembershipDetail').on('show.bs.modal', function(e) {
        if ( $(e.relatedTarget).parents('#modalOnlineMembershipAppointment').length )
        {
            $('#modalMembershipDetail .jsModalCloseLink .jsModalCloseClassic').hide();
            $('#modalMembershipDetail .jsModalCloseLink .jsModalCloseResults').show();
        }
        else
        {
            $('#modalMembershipDetail .jsModalCloseLink .jsModalCloseClassic').show();
            $('#modalMembershipDetail .jsModalCloseLink .jsModalCloseResults').hide();   
        }
    });

});